export const colors = {
    success: '#239D58',
    failure: '#DD4322',
    warning: '#EE9923',
    gold: '#ffd700',
    silver: '#c0c0c0',
    bronze: '#967444',
    primary: {
        // main: '#D61F1F',
        main: '#b73c3c',
        // accent: '#F0C808',
        accent: '#efd34b',
        lighter: '#FF5656',
        text: '#FFFFFF',
    },
    secondary: {},
    grays: {
        100: '#122131',
        80: '#3A425C',
        60: '#708090',
        40: '#ABB1C6',
        20: '#F1F4F6',
        0: '#FFFFFF',
    },
}

export default colors
